import { useState, useContext, useEffect, useCallback } from "react";
import { AlertContext } from '../contexts/AlertContext';
import { LoaderContext } from '../contexts/LoaderContext';
import { SocketContext } from "../contexts/SocketContext";

export const useAreas = () => {

    const [areas, setAreas] = useState([]);

    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader} = useContext(LoaderContext);

    useEffect(() => {
        let unsubscribed = true;
        unsubscribed && obtenerAreas();

        return () => unsubscribed = false;
    }, []);

    const obtenerAreas = useCallback(() => {
        setOpenLoader(true);

        socket.emit('frontend:obtener-areas', (response) => {
            const { ok, message, data } = response;
    
            if(!ok) {
                setOpenLoader(false);
                alertRef?.current?.handleOpen('error', message);
                return;
            }
            
            setAreas(data);
            setOpenLoader(false);
        });
    }, []);

    return {
        areas
    }
}